import React, { CSSProperties, useState } from 'react';
import Button from '../../../components/CustomButtons/ButtonTS';
import ArrowDownwardOutlined from '@material-ui/icons/ArrowDownwardOutlined';
import Tooltip from "@material-ui/core/Tooltip";

type DownloadFileButtonProps = {
	file: any;
	getSystemFile: (ID: number, filename: string) => void;
};

const buttonStyle: CSSProperties = {
	textTransform: 'uppercase',
	margin: '15px',
};

const DownloadFileButton = ({
    file,
	getSystemFile,
}: DownloadFileButtonProps) => {
	const [isButtonDisabled, setIsButtonDisabled] = useState(false);

	const download = () => {
		setIsButtonDisabled(true);
		getSystemFile(file.id, file.filename);
	};

	return (
        <Tooltip title='Download'>
		<Button
			size='sm'
			style={buttonStyle}
			color='info'
			onClick={download}
			disabled={false}
		>
			<ArrowDownwardOutlined/>
		</Button>
        </Tooltip>
	);
};

export default DownloadFileButton;
